import React from 'react';
import {HtmlDisplay} from "../../Display";

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */

interface ButtonMockProps {
	name: string;
	label: string;
	className?: string;
	hideLabel?: boolean;
	disabled?: boolean;
}

export const ButtonMock: React.FC<ButtonMockProps> = ({
	                    name,
	                    label,
                        className,
                        hideLabel,
						disabled
					}: ButtonMockProps) => {
    const buttonClass = "button is-notClickable " + className + (disabled ? " is-disabled " : "");
    const labelClass = hideLabel ? " is-visuallyhidden " : "";

	return (
		<span className={buttonClass}
              tabIndex={0}
              id={name}>
			<HtmlDisplay html={label} className={labelClass} />
		</span>
	);
};
